module.exports = __webpack_public_path__ + "prod/1.42.2/img/taobao-icon.9a85e3b0.png";